<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="120px"
        :inline="false"
        size="normal"
        :disabled="formDisabled"
      >
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            placeholder="请输入标题"
            maxlength="150"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            v-model.trim="form.content"
            placeholder="请输入内容"
            maxlength="200"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="公众号链接" prop="linkUrl">
          <el-input
            v-model.trim="form.linkUrl"
            placeholder="请输入价格"
            maxlength="150"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否发布" prop="isPublish">
          <el-radio-group v-model="form.isPublish">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">轮播</el-radio>
            <el-radio :label="2">瓦力课堂</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片" prop="picUrl">
          <el-upload
            :class="bindClass(1, 'picUrl')"
            action
            multiple
            ref="staffImgUpload"
            :file-list="fileList"
            :limit="1"
            :on-exceed="surpass"
            list-type="picture-card"
            :http-request="imageImportFile"
            :on-remove="imageRemove"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="发布时间" required>
          <el-col :span="11">
            <el-form-item prop="publishTime">
              <el-date-picker
                v-model="form.publishTime"
                type="datetime"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>

      <span slot="footer" v-if="!formDisabled">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import { httpAction, uploadAction } from "@/api/manage";

import { listMixin } from "@/mixins/listMixin";
import { convertTime } from "@/utils/util";

var validateInput = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入名称"));
  }
  let newValue = value.replace(/[<>/\\]/g, "");
  if (newValue !== value) {
    callback(new Error("请勿输入特殊字符"));
  } else {
    callback();
  }
};
export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      formDisabled: false,
      disableMixinCreated: true,
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: { picUrl: [], },
      validatorRules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { max: 100, message: "长度在 100 个字符以内", trigger: "change" },
          {
            validator: validateInput,
            message: "不可以输入特殊符号",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入内容", trigger: "blur" },
          { max: 150, message: "长度在150个字符以内", trigger: "change" },
        ],
        linkUrl: [
          { required: true, message: "请输入价格", trigger: "blur" },
          { max: 150, message: "长度在150 个字符以内", trigger: "change" },
        ],
        isPublish: [{ required: true, message: "请选择是否发布", trigger: "change" }],
        type: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        publishTime: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
      },
      url: {
        add: "/wlImageText/addImageText",
        upload: "/api/upload",
        detail: "/wlImageText/imageText/get/",
      },
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    bindClass(num, name) {
      if (num <= this.form[name]?.length) return "hide";
      else if (this.formDisabled) return "hide";
      else return "show";
    },
    beforeAvatarUpload(file) {
      let types = ["image/jpeg", "image/jpg", "image/bmp", "image/png"];
      const isIMG = types.includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isIMG) {
        this.$message.error("上传图片只能是 JPG、JPEG、bmp、PNG 格式!");
      }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isIMG && isLt10M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    imageImportFile(file) {
      let formData = new FormData();
      formData.append("businessType", 181);
      formData.append("file", file.file, file.file.name);
      uploadAction(this.url.upload, formData)
        .then((res) => {
          this.$message.success("上传成功");
          this.form.picUrl = res.data[0]
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("上传失败");
        });
    },
    imageRemove(e) {
      console.log(e);
      this.form.picUrl = ''
      console.log(this.form);
    },
    surpass() {
      this.$message.warning("图片超过限定张数!");
    },
    add() {
      this.edit();
    },
    edit(record, type) {
      console.log("🚀 ~ edit ~ record:", record)
      this.formDisabled = type;
      record &&
        httpAction(this.url.detail + record.id, {}, "get").then((res) => {
          if (res.code === 200) {
            res.data.publishTime = new Date(res.data.publishTime);
            this.fileList.push({ uid: 0, url: res.data.picUrl || "https://img.tukuppt.com/png_preview/00/04/81/SYZxWQlAr9.jpg!/fw/780" });
            this.form = res.data;
          }
        });
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.fileList = [];
      this.form = { picUrl: '' };
      this.$emit("close");
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.type == 1 && !this.form.picUrl) return this.$message.warning("轮播类型必须上传图片");
          if (this.form.type == 2 && this.form.picUrl) return this.$message.warning("瓦力课堂类型请勿上传图片");
          that.confirmLoading = true;
          that.form.publishTime = convertTime(that.form.publishTime);
          let httpurl = "";
          let method = "";
          const parms = { ...this.form };
          if (!this.form.id) {
            httpurl += this.url.add;
            method = "post";
          } else {
            httpurl += this.url.edit;
            method = "post"; //put
            parms.userId = this.form.id;
          }
          httpAction(httpurl, parms, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success("操作成功");
                that.$emit("ok");
              } else {
                that.$message.warning(res.msg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.show /deep/ .el-upload--picture-card {
  display: block;
}
</style>
